import React, { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { subscribe } from "lib/live_events"
import { isNull } from "lodash"

import allMessages from '../../libs/api/allMessages'
import importData from '../../libs/store/utils/import_data'
import { addUnique } from "../utils"

const MessagesContext = createContext(null)

export function MessagesProvider({ children }) {
  const dispatch = useDispatch()

  const [messages, setMessages] = useState([])
  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(true)
  const [total, setTotal] = useState(null)

  const pullFromServer = useCallback(async (page = 0) => {
    try {
      const { data } = await allMessages({ page, per_page: 10 })
      importData(dispatch, data.data)
      setTotal(data.total)
      setMessages(messages => addUnique(messages, data.list))
      setLoading(false)
    } catch (err) {
      console.error("Failed to fetch messages:", err)
    }
  }, [dispatch, setMessages, setLoading, setTotal])

  // 🔹 Initial fetch
  useEffect(() => {
    if (isNull(page)) {
      setMessages([])
      setTotal(null)
      return
    }

    setLoading(true)
    pullFromServer(page)
  }, [page, pullFromServer])

  const setNewPage = useCallback(newPage => {
    setPage(page => !newPage || !page || newPage > page ? newPage : page)
  }, [setPage])

  const value = useMemo(() => ({ 
    messages, total, page, setPage: setNewPage, loading, allLoaded: messages.length == total
  }), [messages, total, page, setNewPage, loading])

  return (
    <MessagesContext.Provider value={value}>
      {children}
    </MessagesContext.Provider>
  )
}

export function useMessagesContext() {
  return useContext(MessagesContext)
}
